'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

var _recompose = require('recompose');

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _planEnquiryAnalyticsService = require('../planEnquiryAnalyticsService');

var _PlanOption = require('./PlanOption');

var _PlanOption2 = _interopRequireDefault(_PlanOption);

var _Icon = require('../../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _ElementCount = require('../../../../workspace/header/utils/account/billingStatus/ElementCount');

var _ElementCount2 = _interopRequireDefault(_ElementCount);

var _elementCountSelector = require('../../../elementCount/elementCountSelector');

var _notificationConstants = require('../../../../../common/notifications/notificationConstants');

require('./UpgradePlan.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
var elementCountSelector = (0, _reselect.createStructuredSelector)({
    elementCount: _elementCountSelector.contentElementCountSelector,
    contentTotalCount: _elementCountSelector.contentTotalCountSelector,
    contentTotalLimit: _elementCountSelector.contentTotalLimitSelector
});

// Constants


// selector


// Analytics


// Styles


var getEmailHref = function getEmailHref(_ref) {
    var currentUser = _ref.currentUser;
    return 'mailto:' + _notificationConstants.MILANOTE_EMAILS.SUPPORT + '?subject=Enterprise enquiry: ' + currentUser.get('email') + ('&body=Hi Milanote team,\n' + _notificationConstants.URL_ENCODINGS.NEW_LINE + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\nI\'m interested in your enterprise plans.' + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\nPlease contact ' + currentUser.getIn(['name', 'displayName']) + ' at ' + currentUser.get('email') + '.\n' + _notificationConstants.URL_ENCODINGS.NEW_LINE + _notificationConstants.URL_ENCODINGS.NEW_LINE + '\nThanks');
};

var UpgradePlan = function UpgradePlan(props) {
    return _react2.default.createElement(
        'div',
        { className: 'UpgradePlan' },
        _react2.default.createElement(
            'div',
            { className: 'plan-options' },
            _react2.default.createElement(
                _PlanOption2.default,
                null,
                _react2.default.createElement(_Icon2.default, { name: 'payment-free' }),
                _react2.default.createElement(
                    'div',
                    { className: 'details' },
                    _react2.default.createElement(
                        'h3',
                        null,
                        'Free'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'description' },
                        'Free with no time limit'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'cta free' },
                    _react2.default.createElement(
                        'p',
                        { className: 'storage' },
                        _react2.default.createElement(
                            'strong',
                            null,
                            props.contentTotalLimit,
                            ' notes, images or links'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'price' },
                        'FREE'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'count' },
                        _react2.default.createElement(
                            _ElementCount2.default,
                            props,
                            'Your current plan \u2013',
                            ' '
                        )
                    )
                )
            ),
            _react2.default.createElement(
                _PlanOption2.default,
                null,
                _react2.default.createElement(_Icon2.default, { name: 'payment-individual' }),
                _react2.default.createElement(
                    'div',
                    { className: 'details' },
                    _react2.default.createElement(
                        'h3',
                        null,
                        'Professional'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'description' },
                        'For solo professionals'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'cta' },
                    _react2.default.createElement(
                        'p',
                        { className: 'storage' },
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Unlimited storage'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'price' },
                        '$12 / month'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'disclaimer' },
                        'per person billed annually ',
                        _react2.default.createElement('br', null),
                        '$15 when billed monthly'
                    ),
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { to: '/account/payment', className: 'FormButton primary' },
                        'Upgrade now'
                    )
                )
            ),
            _react2.default.createElement(
                _PlanOption2.default,
                null,
                _react2.default.createElement(_Icon2.default, { name: 'payment-team' }),
                _react2.default.createElement(
                    'div',
                    { className: 'details' },
                    _react2.default.createElement(
                        'h3',
                        null,
                        'Professional team'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'description' },
                        'Sign up 2+ people and save.'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'cta' },
                    _react2.default.createElement(
                        'p',
                        { className: 'storage' },
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Unlimited storage'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'price' },
                        '$10 / month'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'disclaimer' },
                        'per person billed annually ',
                        _react2.default.createElement('br', null),
                        '$12.50 when billed monthly'
                    ),
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { to: '/account/team', className: 'FormButton primary' },
                        'Upgrade your team'
                    )
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'enterprise-option' },
            'Part of a larger team?',
            ' ',
            _react2.default.createElement(
                'a',
                { href: getEmailHref(props), onClick: _planEnquiryAnalyticsService.enterprisePlanEnquiryAnalytics },
                'Contact us about our enterprise plan'
            )
        )
    );
};

UpgradePlan.propTypes = {
    currentUser: _propTypes2.default.object.isRequired,
    contentTotalLimit: _propTypes2.default.number
};

var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(elementCountSelector), (0, _recompose.lifecycle)({
    componentWillMount: _planEnquiryAnalyticsService.googleAnalyticsPlanViewEvent
}));

exports.default = enhance(UpgradePlan);


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/plan/upgrade/UpgradePlan.js
// module id = 2076
// module chunks = 0